import React from 'react';
import './Rater.css';

const ChangeLog = () => {
    return (
        <div>
            <p><b>20/06/2026</b></p>
            <p className="info-body">- Add dark mode</p>
            <p className="info-body">- Add option to paste screenshot directly instead of uploading the image</p>
            <p className="info-body">- Modify the logic for choosing Standard companion in Memories page</p>
            <p className="info-body">- Change stellactrum circle to reflect the protocore type symbols</p>
            <p className="info-body">- Change scrollbar style and Gamma protocore type symbol</p><br/>
            <p><b>15/04/2026</b></p>
            <p className="info-body">- Add a <b>new feature</b>! 'Memories' page is now available</p>
            <p className="info-body">- In 'Memories' page, protocores can be equipped to cards to check for damage differences specifically for your team setup and companion</p>
            <p className="info-body">- In 'Memories' page, team image can be viewed and downloaded</p>
            <p className="info-body">- In 'Rater' page, team data can be exported with protocore list</p>
            <p className="info-body"><i>Please note that due to calculations and roundings, the display stats may be slightly off.</i></p>
            <p className="info-body"><i>Also, disclaimer: all images for companions and cards do not belong to me, and some recent card images may be missing. They will be added in the future. All icons for stats, attributes, and team image background are drawn by me and they may not be accurate.</i></p><br/>
            <p><b>02/04/2026</b></p>
            <p className="info-body">- Add Caleb: Netherlord companion</p><br/>
            <p><b>24/02/2026</b></p>
            <p className="info-body">- Add an optional field for protocore type</p>
            <p className="info-body">- Add field labels and change some form UI elements</p>
            <p className="info-body">- Move 'None' selection for Substat 3 and Substat 4 to first in the dropdown</p>
            <p className="info-body">- Add 'Strict Crit/DBW Build Rating' toggle</p>
            <p className="info-body">- Add highlight to the companion scaling substat and include recommendation to prioritise protocores with companion scaling substat</p>
            <p className="info-body">- Change rating algorithm to prioritise companion scaling more and accommodate 'Strict Build Rating' feature</p>
            <p className="info-body">- Increase protocore list limit to 60 protocores</p>
            <p className="info-body">- Fix an issue that crashes the rater when trying to rerate a protocore after removing some companions</p><br/>
            <p><b>26/12/2025</b></p>
            <p className="info-body">- Add Sylus: Silverwing Fiend companion</p><br/>
            <p><b>09/10/2025</b></p>
            <p className="info-body">- Add Zayne: God of Annihilation companion</p><br/>
            <p><b>26/07/2025</b></p>
            <p className="info-body">- Add Xavier: King of Darknight companion</p><br/>
            <p><b>01/07/2025</b></p>
            <p className="info-body">- Fix so companion and build selections are not reset when upload screenshots</p><br/>
            <p><b>24/06/2025</b></p>
            <p className="info-body">- Add Upload Screenshot feature to automatically input protocore details (Note: protocore levels cannot be extracted due to in-game UI formatting, always require manual input)</p><br/>
            <p><b>22/06/2025</b></p>
            <p className="info-body">- Add import/export protocore list function</p>
            <p className="info-body">- Fix duplicate past protocore when clicking Reuse Core Data button</p><br/>
            <p><b>21/06/2025</b></p>
            <p className="info-body">- Fix a recommendation text logic for Lemurian Sea God companion</p><br/>
            <p><b>18/06/2025</b></p>
            <p className="info-body">- Add Rafayel: Lemurian Sea God companion</p><br/>
            <p><b>17/06/2025</b></p>
            <p className="info-body">- Fix Reuse Core Data button not setting states for sorted values</p>
            <p className="info-body">- Make dropdown lists have fixed height and scrollable</p><br/>
            <p><b>09/06/2025</b></p>
            <p className="info-body">- Change to make first result expand by default</p><br/>
            <p><b>12/05/2025</b></p>
            <p className="info-body">- Fix build selection color when stellactrum is not chosen</p><br/>
            <p><b>10/05/2025</b></p>
            <p className="info-body">- Fix typo for Expedited Energy Boost option</p><br/>
            <p><b>06/05/2025</b></p>
            <p className="info-body">- Allow multiple companion and build selections, add comparison table</p>
            <p className="info-body">- Add Flat Stat Importance toggle, change description to include this</p>
            <p className="info-body">- Change history core display to support multiple companions and builds, add main stat evaluation</p>
            <p className="info-body">- Fix minimum roll count</p>
            <p className="info-body">- Change so substats are not disabled when companion, build, stellactrum, level are not selected</p>
            <p className="info-body">- Change interface color to follow stellactrum instead of companion</p>
            <p className="info-body">- Add 'Change Log' and 'Help & Feedback' buttons</p><br/>
            <p><b>20/04/2025</b></p>
            <p className="info-body">- Increase history core number from 10 to 12</p><br/>
            <p><b>19/04/2025</b></p>
            <p className="info-body">- Add delete history core button</p><br/>
            <p><b>18/04/2025</b></p>
            <p className="info-body">- Fix minimum roll count</p><br/>
            <p><b>16/04/2025</b></p>
            <p className="info-body">- Fix decimal in roll count calculations, add reuse core data button, remove level rec for core level 15</p><br/>
            <p><b>14/04/2025</b></p>
            <p className="info-body">- Fix good substat for core list, Farspace Colonel recommendation message, progress bar</p>
            <p className="info-body">- Fix typo, add core level description, add disabled recommendation button</p><br/>
            <p><b>13/04/2025</b></p>
            <p className="info-body">- Initial commit</p>
        </div>
    );
};

export default ChangeLog;